<template>
    <div>
        <div class="w" id="content">
            <div class="s_tl">
                当前位置：<a href="/">首页</a>
                <em class="lr3">&#62;</em>
                <a href="/help">帮助中心</a>
                <em class="lr3">&#62;</em>
                <a href="">新手上路</a>
                <em class="lr3">&#62;</em>
                <a href="">法律声明</a>
            </div>
            <div class="ubg">
                <left-side></left-side>
                <!--left over-->
                <div class="u_r">
                    <div class="ah1 alC yahei">
                        <h1 class="f18">法律声明</h1>
                        <p class="c9">发布时间：2022-01-04</p>
                    </div>
                    <div class="ainfo ov yahei">
                        <p style="text-align:center;font-size:18px;font-weight:bold;">
                            <strong>夜樱情趣法律声明</strong>
                        </p>
                        <p><br></p>
                        <p><br></p>
                        <p style="text-indent:28px;">
                            <strong>权利归属</strong>
                        </p>
                        <p style="text-indent:28px;">
                            除非夜樱情趣另行声明，夜樱情趣推出的所有官方产品、技术、软件、程序、数据及其他信息（包括文字、图标、图片、照片、音频、视频、图表、色彩组合、版面设计等）的所有权利（包括著作权、商标权、专利权、商业秘密及其他相关权利）均归鸿巨网络及/或其关联公司所有。未经鸿巨网络及/或其关联公司事先许可，任何人擅自使用上述内容和信息，可能会侵犯鸿巨网络及/或其关联公司的权利，我们将会追究侵权者的法律责任。如有宣传、展示等任何使用需要，请您务必取得鸿巨网络及/或其关联公司的事先许可。
                        </p>
                        <p style="text-indent:28px;">
                            <strong>信息限制</strong>
                        </p>
                        <p style="text-indent:28px;">  
                            为维护夜樱情趣的正常运行秩序及效率，未经鸿巨网络及/或其关联公司许可，任何人不得自行、授权或协助第三方对夜樱情趣及其系统进行地址扫描、网络端口扫描、操作系统探测等扫描及/或探测，或以包括通过机器人、蜘蛛等程序或设备监视、复制、传播、展示、镜像、上载、下载等方式擅自获取、使用夜樱情趣内的任何内容。
                        </p> 
                        <p style="text-indent:28px;">
                            <strong>责任限制</strong>
                        </p>
                        <p style="text-indent:28px;">
                            鉴于夜樱情趣提供的信息发布服务，夜樱情趣的商品评价信息（包括但不限于产品的描述和说明、相关图片、视频等）由用户自行提供并上传，由用户对其提供并上传的信息承担相应法律责任。夜樱情趣服务提供者对此另有约定的，将在相关的协议或其他法律文本中与您进行明确。
                        </p>
                        <p style="text-indent:28px;">
                            夜樱情趣转载的作品出于传递更多信息之目的，并不意味我们赞同其观点或已经证实其内容的真实性。
                        </p>
                        <p style="text-indent:28px;">
                            <strong>知识产权保护</strong>
                        </p>
                        <p style="text-indent:28px;">
                            我们尊重知识产权，反对并打击侵犯知识产权的行为。知识产权权利人若认为夜樱情趣内容（包括但不限于夜樱情趣用户发布的商品评价信息）侵犯其合法权益的，请联系我们及时处理。
                        </p>
                        <p style="text-align:right;">
                            最新版本生效日期：2020年6月30日
                        </p>
                        <p><br></p>
                    </div>
                    <!--info over-->
                    <p class="lh30"></p>
                    <p class="bline" style="padding: 30px 0px 0 0;"></p>
                    <p class="lh30"></p>
                    <p style="font-size:16px;">
                        <a href="/help/yinsizhengce" style="float:left;">上一篇:隐私权政策</a>
                        <a href="/help/fuwuxieyi" class="pl10" style="float:right">下一篇:服务协议</a>
                    </p>
                </div>
                <!--right over-->
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Left_side from "@/components/help/left-side"
export default {
    components:{
        'left-side': Left_side
    },
}
</script>

<style scoped>
.ainfo {line-height: 32px;padding-top: 10px;font-size: 14px;}
.ubg{border:1px solid #e5e5e5;background-color:#fff;overflow:hidden;}
.u_l{width:170px;padding:10px;background:#fff;border-right:1px solid #e5e5e5;}
.u_r{padding:10px 40px 30px 40px;border-left:1px solid #e5e5e5;line-height:25px;background:#fff;margin-left:190px;min-height:600px;}
.dsl{display:inline;font-weight:normal;}
.udl{margin:0 5px 15px 5px;}
.udl dt{border-bottom:1px solid #e5e5e5;line-height:40px;display:block;font-size:14px;color:#333;font-weight:bold;margin-bottom:10px;}
.udl dd{line-height:30px;text-indent:15px;}
.udl a{display:block;color:#777;margin-bottom:1px;}
.udl a:hover,.udl a.on{color:#c40000;text-decoration:none; background-color:#e5e1e1;}
.article{width:100%;}
.article li{border-bottom:1px dashed #ddd;display:block;width:100%;font-size:14px;line-height:45px;}
.article a{display:block;width:100%;overflow:hidden;}
.article a:hover{color:#c40000;}
.ah1{color:#333;line-height:30px;padding-bottom:10px;border-bottom:2px solid #ddd;}
.a_goods a{width:220px;height:280px;display:inline;float:left;margin:10px 6px;line-height:18px;white-space:nowrap;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/components/help/falvshengming.vue